import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../ui/accordion";
import { FAQ as FAQ_DATA } from "../../data";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="relative py-24 sm:py-32 bg-[#050505]"
  >
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-[#E879F9] font-bold mb-4">
          05 — Questions
        </p>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-6xl leading-[0.95] mb-12">
          Good to <span className="text-[#b533ff]">know.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {FAQ_DATA.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-white/10"
            >
              <AccordionTrigger className="font-display font-bold uppercase text-base sm:text-lg text-white py-6 hover:no-underline hover:text-[#b533ff] [&>svg]:text-[#b533ff]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-gray-400 font-light leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
